var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"dashboard-business"}},[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4",on:{"click":_vm.openStory}},[_c('statistics-card-line',{staticClass:"mb-base",attrs:{"hideChart":"","icon":"EyeIcon","statistic":"","statisticTitle":"Story"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }